import {
  Button,
  ButtonGroup,
  CheckboxWithLabel,
  Currency,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  ErrorLoad,
  Sticky,
  StickyContainer,
  Tabs
} from "@wg/wows-react-uikit"
import { Tab } from '@wg/wows-react-uikit/Tabs'
import filter from "lodash/filter"
import get from "lodash/get"
import indexOf from "lodash/indexOf"
import isEmpty from "lodash/isEmpty"
import isUndefined from "lodash/isUndefined"
import maxBy from "lodash/maxBy"
import moment from "moment"
import React, { Fragment, PureComponent } from "react"
import { Interpolate } from "react-i18next"
import dwhExport from '~/dwhExport'
import { ContainerClanWars_Props } from '../../Containers/ContainerClanWars'
import { t, x } from "../../helpers/localization"
import { getNationUrl } from "../../helpers/nationsAndShips"
import {
  CompetitionMetric
} from "../../Reducers/ReducerClanWars"
import { IS_DEV_MODE } from "../../Reducers/ReducerSupply"
import {
  iHavePermission,
  permissions
} from "../../roles"
import settings from "../../settings"
import { COMPETITION_METRIC } from "../UIKit/UIKit"
import AttemptTable from "./AttemptTable/AttemptTable"
import Calendar from "./Calendar/Calendar"
import ClanWarsHistory from "./ClanWarsHistory/ClanWarsHistory"
import ClanWarsWelcome from "./ClanWarsWelcome"
import ClassNationHistoryTable from "./ClassNationHistoryTable/ClassNationHistoryTable"
import CWarsDebug from "./CWarsDebug/CWarsDebug"
import LastRoundResults from "./LastRoundResults/LastRoundResults"
import ResultsHeader from "./ResultsHeader/ResultsHeader"
import ClanRatingTab from "./Tabs/ClanRatingTab/ClanRatingTab"
import MyWarTab from "./Tabs/MyWarTab/MyWarTab"
import RulesTab from "./Tabs/RulesTab/RulesTab"
import styles from "./ViewClanWars.scss"

export interface ViewSupply_State { }

export type IMonth = Array<string>
const month: IMonth = [t('Январь'), t('Февраль'), t('Март'), t('Апрель'), t('Май'), t('Июнь'), t('Июль'), t('Август'), t('Сентябрь'), t('Октябрь'), t('Ноябрь'), t('Декабрь')]

export const getReachedGradeTooltipBody = (competitionMetric: CompetitionMetric) => {
  switch (competitionMetric) {
    case COMPETITION_METRIC.EXP: {
      return t('Количество чистого опыта, обеспечивающее увеличение результата клана')
    }
    case COMPETITION_METRIC.DAMAGE: {
      return t('Количество урона, обеспечивающее увеличение результата клана')
    }
    case COMPETITION_METRIC.RIBBONS: {
      return t('Количество лент, обеспечивающее увеличение результата клана')
    }
    default: {
      return ''
    }
  }
}

export const getBattleMeticText = (competitionMetric: CompetitionMetric) => {
  switch (competitionMetric) {
    case COMPETITION_METRIC.EXP: {
      return t('Опыт боя')
    }
    case COMPETITION_METRIC.DAMAGE: {
      return t('Урон за бой')
    }
    case COMPETITION_METRIC.RIBBONS: {
      return t('Лент за бой')
    }
    default: {
      return ''
    }
  }
}

export const getBattleMeticTooltipBody = (competitionMetric: CompetitionMetric) => {
  switch (competitionMetric) {
    case COMPETITION_METRIC.EXP: {
      return t('Чистый опыт полученный в бою, при попытке взять планку')
    }
    case COMPETITION_METRIC.DAMAGE: {
      return t('Количество урона, нанесенного в бою, при попытке взять планку')
    }
    case COMPETITION_METRIC.RIBBONS: {
      return t('Количество лент, полученных во время боя, при попытке взять планку')
    }
    default: {
      return ''
    }
  }
}

class ViewClanWars extends PureComponent<ContainerClanWars_Props, ViewSupply_State> {

  componentDidMount() {
    dwhExport.send('naval_battles.open_page')
  }
  renderTab() {
    switch (this.props.selectedTab) {
      case 0:
        {
          if (!this.props.commonInfo.clan.settings.isParticipating || !this.props.clanId) {
            return (
              <ClanWarsWelcome
                autoParticipation={this.props.commonInfo.clan.settings.joinRoundAutomatically}
                toggleAutoParticipation={this.props.toggleAutoParticipation}
                setIsParticipant={this.props.setIsParticipant}
                currentAccount={this.props.currentAccount}
                clanId={this.props.clanId}
                navigateToRecommendations={this.props.navigateToRecommendations}
              />
            )
          } else {
            return (
              <MyWarTab
                currentAccount={this.props.currentAccount}
                prepageStageTabIndex={this.props.prepageStageTabIndex}
                setPrepareStageTab={this.props.setPrepareStageTab}
                autoParticipation={this.props.autoParticipation}
                toggleAutoParticipation={this.props.toggleAutoParticipation}
                showNationShipTypeStatistic={this.props.showNationShipTypeStatistic}
                showAttemptsModal={this.props.showAttemptsModal}
                hideAttemptsModal={this.props.hideAttemptsModal}
                showCalendarModal={this.props.showCalendarModal}
                hideCalendarModal={this.props.hideCalendarModal}
                togglePlayersCountInRating={this.props.togglePlayersCountInRating}
                setUseAttempts={this.props.setUseAttempts}
                selectedAttemptsUserId={this.props.selectedAttemptsUserId}
                allPlayersInRatingTable={this.props.allPlayersInRatingTable}
                clanInfo={this.props.clanInfo}
                commonInfo={this.props.commonInfo}
                stages={this.props.stages}
                warSettings={this.props.warSettings}
                groupedBattles={this.props.groupedBattles}
                restriction={this.props.restriction}
                nextWeekStartDate={this.props.nextWeekStartDate}
                useAttempts={this.props.useAttempts}
                isFromPort={this.props.isFromPort}
                showLastRoundResults={this.props.showLastRoundResults}
                lastRoundResults={this.props.lastRoundResults}
                ships={this.props.ships}
                showHistoryModal={this.props.showHistoryModal}
                hideHistoryModal={this.props.hideHistoryModal}
                refreshHistoryModal={this.props.refreshHistoryModal}
                roundsHistory={this.props.roundsHistory}
              />
            )
          }

        }
      case 1:
        {
          return (
            <ClanRatingTab
              settings={this.props.settings}
              currentAccount={this.props.currentAccount}
              selectedClanRatingLeague={this.props.selectedClanRatingLeague}
              clanRatingLeagues={this.props.warSettings.leagues}
              selectRatingLeague={this.props.selectRatingLeague}
              searchInputValue={this.props.searchInputValue}
              searchInputChange={this.props.searchInputChange}
              getRatings={this.props.getRatings}
              ratingsSearch={this.props.ratingsSearch}
              clanRatingList={this.props.clanRatingList}
              clanRatingSearchList={this.props.clanRatingSearchList}
              clanRatingAutocomplete={this.props.clanRatingAutocomplete}
              selectedClanId={this.props.selectedClanId}
              clearSearch={this.props.clearSearch}
              showOwnClanPosition={this.props.showOwnClanPosition}
              showSeasonLeaders={this.props.showSeasonLeaders}
              navigateToClan={this.props.navigateToClan}
              commonInfo={this.props.commonInfo}
            />
          )
        }
      case 2:
        {
          return (
            <RulesTab
              stages={this.props.stages}
              warSettings={this.props.warSettings}
              clanId={this.props.clanId}
              navigateToRecommendations={this.props.navigateToRecommendations}
            />
          )
        }
      default:
        {
          return null
        }

    }
  }

  getNationShipTypeNextGrade(battles) {
    const {
      grades,
      topGradesIncrement
    } = this.props.warSettings.stages.war
    let reachedGrade = null
    let reachedGradeIndex = null
    let nextGrade = null

    battles.sort((a, b) => {
      return a.claimedGrade - b.claimedGrade
    })

    if (!isEmpty(battles)) {
      reachedGrade = battles[battles.length - 1].claimedGrade
      reachedGradeIndex = indexOf(grades, reachedGrade)

      nextGrade = reachedGradeIndex !== -1 && !isUndefined(grades[reachedGradeIndex + 1]) ? grades[reachedGradeIndex + 1] : reachedGrade + this.props.topGradesIncrement


      return nextGrade ? nextGrade : reachedGrade + topGradesIncrement

    } else {
      return grades[0]
    }
  }

  renderNationShipTypeModalContent(battles) {
    const battlesWithReachedGrade = filter(battles, battle => {
      return battle.isReachedGrade || (battle.startedAt && !battle.finishedAt)
    })

    const sortedBattles = !isEmpty(battlesWithReachedGrade) ? battlesWithReachedGrade.filter(battle => !!battle.ship).sort((a, b) => {
      if (a.claimedGrade < b.claimedGrade) {
        return -1
      }
      if (a.claimedGrade > b.claimedGrade) {
        return 1
      }
      return 0
    }) : null

    const lastBattle = sortedBattles ? sortedBattles[sortedBattles.length - 1] : null

    return (
      <div>
        <ResultsHeader
          withMedal={false}
          params={[{
            value: battlesWithReachedGrade.length,
            label: t('Результат'),
            type: 'cwars-star',
            tooltipBody: t('Количество взятых планок')
          }, {
            value: lastBattle ? lastBattle.claimedGrade : '—',
            label: t('Лучшая планка'),
            type: Currency.metricIconName[this.props.warSettings.stages.preparation.competitionMetric],
            tooltipBody: t('Наивысшая взятая планка')
          }, {
            value: this.getNationShipTypeNextGrade(battlesWithReachedGrade),
            label: t('Следующая планка'),
            type: Currency.metricIconName[this.props.warSettings.stages.preparation.competitionMetric],
            tooltipBody: t('Ближайшая невзятая планка')
          }]}
        />
        <h2 className={styles.dialogHeader}>{t('Результативные попытки')}</h2>

        <ClassNationHistoryTable
          battles={battlesWithReachedGrade}
          grades={this.props.warSettings.stages.war.grades}
          topGradesIncrement={this.props.warSettings.stages.war.topGradesIncrement}
          ships={this.props.ships}
          competitionMetric={this.props.warSettings.stages.preparation.competitionMetric}
        />
      </div>
    )
  }

  getNationShipTypeStatisticModalContent = () => {
    const {
      selectedStatisticNation,
      selectedStatisticType
    } = this.props

    const battles = get(this.props.groupedBattles, `${selectedStatisticNation}.${selectedStatisticType}`, [])

    return (
      <Fragment>
        <div>
          <DialogHeader>
            {t('Текущие результаты')}
          </DialogHeader>
          {selectedStatisticNation ? <div className={styles.nationShipTypeModalBackground}>
            <img src={getNationUrl(selectedStatisticNation, 'large')} alt="" />
          </div> : null}
          <DialogBody className={styles.dialogBodyWrapper}>
            {this.renderNationShipTypeModalContent(battles)}
          </DialogBody>
        </div>
        <DialogFooter>
          <Button onClick={this.props.hideStatModal}> {t('Закрыть')} </Button>
        </DialogFooter>
      </Fragment>
    )
  }

  getAttemptModalContent = () => {
    const userBattles = filter(this.props.stages.war.battles, battle => {
      return battle.spaId === this.props.selectedAttemptsUserId
    })

    const reachedBattles = filter(userBattles, battle => {
      return battle.isReachedGrade
    })

    const maxReachedGradeItem = maxBy(reachedBattles, battle => {
      return battle.claimedGrade
    })

    let maxReachedGrade = 0
    if (maxReachedGradeItem) {
      maxReachedGrade = maxReachedGradeItem.claimedGrade
    }
    let userNickname = ''

    if (!isEmpty(userBattles)) {
      userNickname = this.props.currentAccount.id === this.props.selectedAttemptsUserId ? this.props.currentAccount.nickname : userBattles[0].nick
    }

    const maxPersonalAttempts = this.props.warSettings.stages.war.maxPersonalAttempts

    return (
      <Fragment>
        <div>
          <DialogHeader>{t('История попыток')}</DialogHeader>
          <DialogBody className={styles.dialogBodyWrapper}>
            {(userBattles && userBattles.length > 0) ? (
              <Fragment>
                <h2 className={styles.dialogHeader}>
                  <Interpolate i18nKey={x('Личный результат игрока %(nick)s')} nick={userNickname} />
                </h2>
                <ResultsHeader withMedal={false} params={[{
                  value: reachedBattles.length,
                  label: t('Результат'),
                  type: 'cwars-star',
                  tooltipBody: t('Количество взятых планок')
                }, {
                  value: `${userBattles.length}/${maxPersonalAttempts}`,
                  label: t('Попытки'),
                  tooltipBody: t('Количество использованных попыток взятия планок')
                }, {
                  value: maxReachedGrade,
                  label: t('Лучшая планка'),
                  type: Currency.metricIconName[this.props.warSettings.stages.preparation.competitionMetric],
                  tooltipBody: t('Наивысшая взятая планка')
                }]} />


                <AttemptTable
                  battles={userBattles}
                  ships={this.props.ships}
                  competitionMetric={this.props.warSettings.stages.preparation.competitionMetric}
                />
              </Fragment>
            ) : (
                <span className={styles.onAttemptsMessage}>
                  {t('Вы еще не тратили свои попытки')}
                </span>
              )}
          </DialogBody>
        </div>
        <DialogFooter>
          <ButtonGroup>
            <Button onClick={this.props.hideAttemptsModal}>
              {t('Закрыть')}
            </Button>
          </ButtonGroup>
        </DialogFooter>
      </Fragment>
    )
  }

  getDateMonth = (date: string) => {
    if (date) {
      return month[parseInt(moment.utc(date).format('M'), 10) - 1]
    } else {
      return null
    }
  }

  getHistoryModalContent = () => {
    return (
      <ClanWarsHistory
        id={'ClanWarsHistory'}
        hideHistoryModal={this.props.hideHistoryModal}
        loadHistory={this.props.loadHistory}
        roundsHistory={this.props.roundsHistory}
        roundsHistoryCount={this.props.roundsHistoryCount}
        roundsHistoryOffset={this.props.roundsHistoryOffset}
        roundsHistoryLimit={this.props.roundsHistoryLimit}
        isRoundsHistoryLoading={this.props.isRoundsHistoryLoading}
        clanInfo={this.props.clanInfo}
        commonInfo={this.props.commonInfo}
        warSettings={this.props.warSettings}
        currentAccount={this.props.currentAccount}
        refreshHistoryModal={this.props.refreshHistoryModal}
      />
    )
  }

  getCalendarModalContent = () => {

    let month = ''

    const weeksCount = 4
    const currentWeek = 2
    const firstDateWeekIndex = 1
    const firstDateDayIndex = 1
    const lastDateWeekIndex = 4
    const lastDateDayIndex = 7

    const firstDateDayOffset = Calendar.getDayOffset(firstDateWeekIndex, firstDateDayIndex, currentWeek)
    const lastDateDayOffset = Calendar.getDayOffset(lastDateWeekIndex, lastDateDayIndex, currentWeek)

    const firstDate = Calendar.getDateDayNumber(firstDateDayOffset)
    const lastDate = Calendar.getDateDayNumber(lastDateDayOffset)

    const firstMonth = this.getDateMonth(firstDate)
    const lastMonth = this.getDateMonth(lastDate)

    if (firstMonth && lastMonth) {
      if (firstMonth === lastMonth) {
        month = `${firstMonth}`
      } else {
        month = `${firstMonth} — ${lastMonth}`
      }
    }

    return <Fragment>
      <DialogHeader>
        <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Календарь морских сражений за %(period)s')} period={month} parent={'span'} />
      </DialogHeader>
      <DialogBody className={styles.dialogBodyWrapper}>
        <Calendar currentWeek={currentWeek} weeksCount={weeksCount} currentStage={this.props.stages.currentStage} currentRound={this.props.warSettings.currentRound} stages={this.props.warSettings.stages} />
        <div className={styles.checkbox}>
          {iHavePermission(permissions.CWARS_TOGGLE_PARTICIPATION, this.props.currentAccount) ? <CheckboxWithLabel labelText={t('Участвовать в морском сражении каждую неделю')} isCenter isChecked={this.props.commonInfo.clan.settings.joinRoundAutomatically} isDisabled={false} onChange={this.props.toggleAutoParticipation} /> : null}
        </div>
        <DialogFooter>
          <ButtonGroup>
            <Button onClick={this.props.hideCalendarModal}>
              {t('Закрыть')}
            </Button>
          </ButtonGroup>
        </DialogFooter>
      </DialogBody>
    </Fragment>
  }

  getLastRoundtModalContent() {
    return <LastRoundResults data={this.props.lastRoundResults} hide={this.props.hideLastRoundResults} warSettings={this.props.warSettings} commonInfo={this.props.commonInfo} />
  }

  reload = () => {
    this.props.init(true)
  }

  render() {
    const isBlured = this.props.isAttemptHistoryModalVisible || this.props.isStatModalVisible || this.props.isCalendarModalVisible

    if (this.props.hasErrors) {
      return <ErrorLoad key="error-load" message={t('Произошла ошибка. Повторите попытку позже')} onReloadClick={this.reload} t={t} />
    }

    if (!this.props.isReady && this.props.clanId) {
      return null
    }

    const userBattles = filter(this.props.stages.war.battles, (battle: any) => {
      return battle.spaId === this.props.selectedAttemptsUserId
    })

    const tabsItems: Array<Tab> = [{ value: '0', content: t('Морское сражение') }]

    tabsItems.push({ value: '1', content: t('Рейтинг кланов') })

    if (settings.cwars.isRulesShown) {
      tabsItems.push({ value: '2', content: t('Правила') })
    }

    return (
      <StickyContainer id={'stickyClanWars'}>
        <div className={styles.wrapper}>
          <div className={`${styles.blurable} ${isBlured ? styles.isBlured : ''}`}>
            <Sticky
              appContainerId={''}
              scrollContainerId={''}
              usedStickyContainerId={'stickyClanWars'}
              isActive={true}
            >
              <div className={`${styles.blurableTabs} ${this.props.isFromPort ? styles.isBluredTabs : ''}`}>
                <Tabs
                  isUppercase
                  smallHeight
                  tabSelected={`${this.props.selectedTab}`}
                  tabs={tabsItems}
                  onToggleTab={(tab: string) => {
                    this.props.setSelectedTab(parseInt(tab, 10))
                  }}
                />
              </div>
            </Sticky>
            {this.renderTab()}
          </div>

          <Dialog
            content={this.getNationShipTypeStatisticModalContent()}
            size={'extra-large'}
            isOverlay={false}
            isVisible={this.props.isStatModalVisible}
            hideDialog={this.props.hideStatModal}
          />

          <Dialog
            content={this.getAttemptModalContent()}
            size={userBattles.length === 0 ? 'small' : 'extra-large'}
            isOverlay={false}
            isVisible={this.props.isAttemptHistoryModalVisible}
            hideDialog={this.props.hideAttemptsModal}
          />

          <Dialog
            content={this.getCalendarModalContent()}
            size={'extra-height'}
            isOverlay={false}
            isVisible={this.props.isCalendarModalVisible}
            hideDialog={this.props.hideCalendarModal}
          />

          <Dialog
            key={`history-${this.props.isRoundsHistoryLoading}`}
            content={this.getHistoryModalContent()}
            size={'extra-large'}
            isOverlay={false}
            isVisible={this.props.isHistoryModalVisible}
            hideDialog={this.props.hideHistoryModal}
          />

          <Dialog
            content={this.getLastRoundtModalContent()}
            size={'extra-large'}
            isOverlay={false}
            isVisible={(!isEmpty(this.props.lastRoundResults) && !this.props.lastRoundResultsHidden)}
            hideDialog={this.props.hideLastRoundResults}
          />

        </div>
        {IS_DEV_MODE ? <CWarsDebug /> : null}
      </StickyContainer>
    )
  }
}

export default ViewClanWars